<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Industry Expertises</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onCreateIndustryExpertise()">
        <mat-icon>add</mat-icon>
        Add Industry Expertise
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="industryExpertises()"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditIndustryExpertise($event)"
      (deleteClick)="onDeleteIndustryExpertise($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-lookup-table>
</div>
